import axiosInstance from './axiosInstance';

const getRequestConfig = (payload) => (
  payload instanceof FormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined
);

export const teamMembersAPI = {
  createTeamMember: async (payload) => {
    const response = await axiosInstance.post('/team-members/', payload, getRequestConfig(payload));
    return response.data;
  },

  updateTeamMember: async (memberId, payload) => {
    const response = await axiosInstance.patch(`/team-members/${memberId}/`, payload, getRequestConfig(payload));
    return response.data;
  },

  deleteTeamMember: async (memberId) => {
    const response = await axiosInstance.delete(`/team-members/${memberId}/`);
    return response.data;
  },
};
